const socketClient = require("socket.io-client");

export const socket = socketClient(process.env.REACT_APP_WEB_URL, {
  query: {
    token: localStorage.getItem("auth_token"),
  },
});
